module.exports = __webpack_public_path__ + "img/4.053fd01f.jpg";